import * as React from 'react';
import { UserContext } from '../Context/UserContext';
import { UserFlagRepository } from '../../MedicareProAPI/Repositories/User/UserFlagRepository';
import { INDIVIDUAL_GENDER_LABELS } from '../Language/en';

export interface IndGenderRendererProps {
  value: string;
}

export const IndGenderRenderer = (props: IndGenderRendererProps): string => {
  const [renderedValue, setRenderedValue] = React.useState<string>(null);
  const [value, setValue] = React.useState<string>(props.value);

  React.useEffect(() => {
    const findGender = INDIVIDUAL_GENDER_LABELS.find(
      (genderSingle) => genderSingle.value === value
    );

    if (findGender) {
      setRenderedValue(findGender.label);
    }
  }, []);

  return renderedValue || value;
};
